// GENERATED by tools/license-keygen.mjs from services/www/src/license/keys.json — do not edit.
// The public keys a license (and the revocation list) must be signed with. docs/features/licenses.md › Keys.
export const LICENSE_KEYS = {
  "v": 1,
  "keys": [
    {
      "id": "mac-perpetual-refundable.test.2026q4",
      "product": "mac-perpetual-refundable",
      "mode": "test",
      "grants": "mac-perpetual",
      "blind": false,
      "alg": "RSASSA-PSS-SHA384",
      "bits": 3072,
      "spki": "MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEAzkheAqyIqWlGac4uOnD8RT2WVK57agwIGYg3HGFLNiIvVcPZIMw3XUjSoxAJi7NieBinnOLRA34Xg0cU4lREoCXls6K0Cvl7y9f_yspWHYZs4sOJQs2NblCtPaigTFViSUPPWsETwLPNVsP62_UAtqEYUbHOhh26VjmXi4Y6qT442313I6Zyw7XdnLoHRhqNJltUBy0FYCc2eRgbrg6klalZDOcK0tR57Qf-bOfNCy0xItAKWroHVvuU65lAAu2hIhaLq_itwpQwHesVSJHrHC2q41e92sxUySeZgv24C2KTZSicQcb-BUFH_pmSj4VfvRYFznDHIEZT_ywpJZI8UQKRlXeS45eBmO0zBwH0ZcdEirLEle72rmggFbnkMpn8rWx3YnKpJ07UM1OTgZBWZfXoNVo-hbEEWxeIEfXQfaRV0GxtNPb-Opw8yJz-CNphmBMzGoHQoLpbpqZxogGlSjRhfrkLMHg4X7EGk38fRUyISMQ555C-SjXeiKugx-K1AgMBAAE"
    },
    {
      "id": "mac-perpetual.test.2026q4",
      "product": "mac-perpetual",
      "mode": "test",
      "grants": "mac-perpetual",
      "blind": true,
      "alg": "RSASSA-PSS-SHA384",
      "bits": 3072,
      "spki": "MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEAs8nFFpNskvIkE37cSWgFL_2xtSEJ9B2eN22-oO2YUwxMd7foKYEPAX6-lx-x7G0UXvkCHJu0IT6XuSZlrh7_gUgfnIYLFtIqy0ALuZNZUlp9DfkWxm708GqEeSD8deHLYXftH_bArzQTHf3t99wfAzCWmVy8_xNuI-NJAVRzNybakO28kDnleEz2LUm3ARIaz5ph6dsqVk2-cntRKpjW6tORAY1pKOmKj4h30izqApmozQgyHXaN4gTuDVX_fmD9zfeG56qo0WAoinJI8mKg4ZgrprF7fKGoRMMQzjjoC4mvn9eXs6wp7hGWihOm9UbREkKEQWnBjb7B6zo6Zmyxwx94uO9nf5g0F8sQZoIVu0p89a2_kFpKaZ6CpJHA0AoHgrSDq91pqze8Mh5MeXEMCYTzqh4fZsD8QyH2o_92UNbdEF-wyjnin_5g6Q0clZgiZO99pcmsSDatXXK9r5JtOKXQTX1syVgPfZSi8yoqQFkO4IqqOGspe18MWeON8YwXAgMBAAE"
    }
  ],
  "lists": [
    {
      "id": "revoked.test.2026q4",
      "mode": "test",
      "alg": "Ed25519",
      "key": "6JQIK2Phc8pDNpW97wE8ZHYr6wq747_XpEcCf_tEZTM"
    }
  ],
  "anchors": [],
  "passes": [
    {
      "id": "relay-pass.test.2026q4",
      "product": "relay-pass",
      "mode": "test",
      "grants": "relay-pass",
      "blind": true,
      "alg": "RSASSA-PSS-SHA384",
      "bits": 3072,
      "spki": "MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEAl9BHppjD56EYkovukxh3uZWxVgorpbeUJ6mcIlcSbQB2yVx2WReoukf460HydZ-j9VqW1BytEPhlBtJqxFYaMbEgBa0vLotSNE2txCKDg_UGxtLPvLhyEu-HQ4-aATWzJZTtxTVYfzy3OuEnSCuGSBsvng9lN0T2A_fq5Nx8mAMxQNjrVzrjIo7i4hOvIWSFOu0fCAnURf6tCgij7IWfKrUQxVhivLIiL_1q7IEyP2R4dcRJXj7ZjXrFsg5-HZk5VnUJLlwwl3v0wR0JselJbhStbc-eBY0vAxUvGuBaYy7s9Mz0VidHIXu02s-FwjVxcyB7vzOq0se9v1md3CWzQ5HnqSKCm57RYUA3iYCVL5uLoo6l6mIf_rTrXH_-U3Ct0nwEWMc_RdGZZbMqtfoW-nZGNsvEKcnHqom_rfF27r6v4naeLBCxOeHfnuuMIBXCTV2zViB1FpWuvBr_Y41sjAAKp3VBZQ51jm2uoZ_ueL1BjMeaSiXNkoqDNSF_wRofAgMBAAE"
    }
  ]
}
